import axios from "../config/axios-chatbot";

// WebRTC agent calling (SIP over WSS through Asterisk), see sip-connector/README_WEBRTC.md "Client contract".
// Every call is scoped to a registry project: /api/project/{projectId}/webrtc/..., with X-Project-Id equal to the
// path id. Errors are {code, error, ...}: branch on webrtcErrorCode.
const base = (projectId) => `/api/project/${projectId}/webrtc`;
const config = (projectId, extra) => ({headers: {"X-Project-Id": projectId}, ...(extra || {})});

// Error code of a failed call ("agent_not_registered", "conversation_not_active", ...), null when there is none
export const webrtcErrorCode = (error) => error?.response?.data?.code || null;

// Message to show for a failed call
export const webrtcErrorMessage = (error, fallback) =>
  error?.response?.data?.message || error?.response?.data?.error || fallback;

export const WebrtcRepository = {
  // -> {agent: {id, sip_id, registered, device_state, ...}, webrtc: {sip_uri, authorization_user, password, ws_url,
  // display_name, ice_servers, ice_credentials_expire_in}}. Creates the agent's WebRTC identity on first use; call it
  // on every connect, it is not cached. The identity is per project: one registration calls for every sub project.
  getMyWebrtc: ({projectId, displayName}) => axios.post(`${base(projectId)}/agent`, {
    display_name: displayName || undefined,
  }, config(projectId)),
  // -> {external_agent_id, provisioned, registered, agent?}
  getWebrtcStatus: ({projectId}) => axios.get(`${base(projectId)}/agent/status`, config(projectId)),
  // -> {conversation_id, external_agent_id, status: "HANDOVER", transfer}: the caller is bridged to the agent's browser.
  // Errors: 404 conversation_not_active, 409 agent_not_registered, 503 ami_unavailable
  handoverToWebrtc: ({projectId, conversationId}) =>
    axios.post(`${base(projectId)}/conversations/${conversationId}/handover`, {}, config(projectId)),
  // {conversationId} or {phoneNumber} -> {action_id, external_agent_id, to_number, caller_id}. The agent's browser
  // rings first ("Call <number>"), then the customer is dialed from the sub project's outbound_call (caller ID and
  // trunk). sub_project_id defaults to the conversation's own.
  // Errors: 400 to_number_required / invalid_phone_number, 404 conversation_not_found,
  // 422 outbound_number_not_configured, 409 agent_not_registered, 503 ami_unavailable
  webrtcCallCustomer: ({projectId, subProjectId, conversationId, phoneNumber}) => axios.post(`${base(projectId)}/calls`, {
    conversation_id: conversationId ?? undefined,
    to_number: conversationId ? undefined : phoneNumber,
    sub_project_id: subProjectId || undefined,
  }, config(projectId)),
  // -> {status: "pending" | "done", outcome: answered | rejected | busy | no_answer | invalid_number | network_error |
  // hangup | congestion | failed | unknown}, of the agent's leg (the customer is dialed once the agent answers)
  pollCallStatus: ({projectId, actionId}) => axios.get(`${base(projectId)}/calls/${actionId}`, config(projectId)),
};
